import { render, staticRenderFns } from "./candidat.vue?vue&type=template&id=452e5440&"
import script from "./candidat.vue?vue&type=script&lang=js&"
export * from "./candidat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports